import { all, fork } from 'redux-saga/effects';
import { LuckyTurnipsSaga } from './LuckyTurnips/LuckyTurnipsSaga';

export function* rootSaga() {
    const sagas = [
        LuckyTurnipsSaga,
    ];

    yield all(sagas.map(fork));
}
